import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import InfoPaymentRecordAdvance from './InfoPaymentRecordAdvance'
import PaymentRecordAdvanceForm from './PaymentRecordAdvanceForm'
import PaymentRecordAdvanceTable from './PaymentRecordAdvanceTable'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { sessionGetItemStr, sessionGetItemObj, sessionSetItemStr } from '../../utils/sessionHelpers'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  savePaymentRecordAdvance,
  deletePaymentRecordAdvance,
} from '../../redux/actions/paymentRecordAdvance'
import moment from 'moment'
import notification from '../../utils/notification'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../utils/globalMsgUtil'
import PaymentRecordAdvanceView from './PaymentRecordAdvanceView'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'

export default function PaymentRecordAdvanceWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [request, setRequest] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const periodInfo = sessionGetItemObj('periodInfo')
  const borrowId = sessionGetItemStr('borrowId')

  let history = useHistory()

  const onSubmit = (data) => {
    // console.log('data submit ', data)
    // return false
    const formData = new FormData()

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    formData.append('Id', formSchema?.id || '')
    formData.append('ProjectCode', projectCode)
    formData.append('PeriodNo', periodInfo.periodNumber || '')
    formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('ReferenceNumber', data.referenceNumber)
    formData.append('AccountChannel', data.accountChannel)
    // formData.append('CashInput', data)
    formData.append('BankAccount', data.bankAccount || '')
    // formData.append('BankInput', data)
    formData.append('VoucherDate', moment(data.voucherDate).format('YYYY/MM/DD') || '')
    formData.append('BorrowedDate', moment(data.borrowedDate).format('YYYY/MM/DD') || '')
    formData.append('StartDateActive', moment(data.startDateActive).format('YYYY/MM/DD') || '')
    formData.append('StopDateActive', moment(data.stopDateActive).format('YYYY/MM/DD') || '')
    // formData.append('ExpenseType', data.expenseType)
    formData.append('DueDate', moment(data.dueDate).format('YYYY/MM/DD') || '')
    // formData.append('Residence', data.residence)
    formData.append('Description', data.description)
    formData.append('ReceiveMoneyEtc', data.receiveMoneyEtc)

    formData.append('CheckDocNumber', data.checkDocNumber || '')
    formData.append(
      'CheckDocDate',
      data.checkDocDate ? moment(data.checkDocDate).format('YYYY/MM/DD') : ''
    )
    formData.append('isDraft', false)
    const formTable = data.table?.filter((i) => !i.isRowTotal) || []

    if (formTable?.length > 0) {
      formTable?.map((item, index) => {
        console.log('item ', item)
        if (item.id) {
          // console.log('item.id ', item.id.includes('addNew'))
          //เช็คว่าเป็นรายการเพิ่มใหม่ หรือ ว่าเป็นรายการแก้ไข
          let _id = item.id.includes('addNew') ? '' : item.id
          formData.set(`FormTable[${index}].Id`, _id || '')
          formData.set(`FormTable[${index}].ActivityCode`, item.listId || '')
          formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        }
      })
    } else {
      notification.open('error', {
        title: globalMsgUtil.MSG_TABLE_LENGTH_OF_ZERO,
      })
      return false
    }

    setRequest(formData)
    setIsShowConfirm(true)
  }
  const DraftOnSumit = () => {
    const data = getValues()

    console.log('draft data', data)

    const formData = new FormData()

    if (Array.isArray(data.attachFiles)) {
      data.attachFiles.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })
    }

    if (Array.isArray(data.deleteFileIds)) {
      data.deleteFileIds.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })
    }

    formData.append('Id', formSchema?.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodNo', periodInfo?.periodNumber || '')
    formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('BankAccount', data.bankAccount || '')

    formData.append(
      'VoucherDate',
      data.voucherDate ? moment(data.voucherDate).format('YYYY/MM/DD') : ''
    )

    formData.append(
      'BorrowedDate',
      data.borrowedDate ? moment(data.borrowedDate).format('YYYY/MM/DD') : ''
    )

    formData.append(
      'StartDateActive',
      data.startDateActive ? moment(data.startDateActive).format('YYYY/MM/DD') : ''
    )

    formData.append(
      'StopDateActive',
      data.stopDateActive ? moment(data.stopDateActive).format('YYYY/MM/DD') : ''
    )

    formData.append('DueDate', data.dueDate ? moment(data.dueDate).format('YYYY/MM/DD') : '')

    formData.append('Description', data.description || '')
    formData.append('ReceiveMoneyEtc', data.receiveMoneyEtc || '')
    formData.append('CheckDocNumber', data.checkDocNumber || '')

    formData.append(
      'CheckDocDate',
      data.checkDocDate ? moment(data.checkDocDate).format('YYYY/MM/DD') : ''
    )

    formData.append('IsDraft', true)

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []

    if (formTable.length > 0) {
      formTable.forEach((item, index) => {
        if (item.id) {
          const _id = item.id.includes('addNew') ? '' : item.id

          formData.set(`FormTable[${index}].Id`, _id || '')
          formData.set(`FormTable[${index}].ActivityCode`, item.listId || '')
          formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        }
      })
    }

    setRequest(formData)
    setIsShowConfirm(true)
  }
  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await savePaymentRecordAdvance(request)
      // console.log('ressss => ** ', response)
      if (response) {
        sessionSetItemStr('borrowId', response.model.id)
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
        })
        setRequest()
        setIsShowConfirm(false)
        setTimeout(() => {
          if (borrowId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
        setIsShowConfirm(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
      setIsShowConfirm(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteVoucher = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await deletePaymentRecordAdvance(borrowId)
      if (response) {
        notification.open('success', {
          title: globalMsgUtil.DELETE_SUCCESS,
        })
        setIsShowConfirmDelete(false)
        history.goBack()
      } else {
        setIsError(true)
        setIsShowConfirmDelete(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
      setIsShowConfirmDelete(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {!formSchema?.disabled ? (
          <>
            <PaymentRecordAdvanceForm
              schema={formSchema?.form}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              setIsEnableEdit={setIsEnableEdit}
              // objectDisabled={formSchema.id ? true : false}
              objectDisabled={formSchema?.form?.isEditTableDisabled}
            />
          </>
        ) : (
          <>
            <PaymentRecordAdvanceView register={register} schema={formSchema?.form} />
          </>
        )}

        <PaymentRecordAdvanceTable
          schema={formSchema?.form?.formTable}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isReceiveAnnuity={formSchema?.form?.isReceiveAnnuity}
          isEnableEdit={!formSchema?.form?.isReceiveAnnuity || isEnableEdit}
          isViewMode={formSchema?.disabled}
          //objectDisabled={formSchema.id ? true : false}
          objectDisabled={formSchema?.form?.isEditTableDisabled}
          isAddDisabled={formSchema?.form?.isAddDisabled}
        />

        <div>
          <br />
          <Row>
            {isError && (
              <Message
                showIcon
                type="error"
                description={isError || 'ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
              />
            )}
            <Col lg={12} md={12} sm={24} xs={24}>
              {/* 08 Mar 2024	: หน้าบันทึกยืมเงินทดรองจ่าย ให้เอาปุ่มลบออกสารออก เอกสารต้องลบไม่ได้ แก้ไขได้เท่านั้น 
               {!formSchema?.disabled && (
                <Button
                  color="red"
                  appearance="link"
                  disabled={!formSchema.id}
                  onClick={() => {
                    setIsShowConfirmDelete(true)
                  }}
                >
                  <Icon icon="trash" size="lg" /> ลบเอกสาร
                </Button>
              )} */}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {/* <Button
                color="blue"
                appearance="link"
                onClick={() => {
                  alert('ใบสำคัญจ่าย')
                }}
              >
                <Icon icon="search" size="lg" /> ใบสำคัญจ่าย
              </Button> */}
              {!formSchema?.disabled && (
                <>
                  {formSchema?.form?.enableSaveDraft && (
                    <SaveButton onClick={DraftOnSumit} disabled={formSchema?.form?.isEditDisabled}>
                      บันทึกร่าง
                    </SaveButton>
                  )}
                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={formSchema?.form?.isEditDisabled}
                  >
                    บันทึก
                  </SaveButton>
                  <CancelButton
                    onClick={() => {
                      history.goBack()
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_DELETE_DOC_TITLE}
        show={isShowConfirmDelete}
        detail={globalMsgUtil.CONFIRM_DELETE_DOC_DETAIL}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleDeleteVoucher}
      />
    </>
  )
}
